import React from "react";
import PDBStructureBase from "./PDBStructureBase";
import Style from "./PDBStructure.module.css";

function PDBStructure({ variant, textLiterals}) {

  const [title, setTitle] = React.useState("");
  React.useEffect(() => {
    setTitle("3D Structure of Spike with Amino Acid Changes");

  }, [textLiterals]);
  return (
    <div>
      <h2 className={Style.title}>
        {title}
      </h2>
      {/* <div  className={Style.subtitle}>
        Click Legend to show/hide areas
      </div> */}

      <PDBStructureBase textLiterals={textLiterals} variant={variant}
      />
      {/* <div id="viewport"/> */}
    </div>
  );
}

export default PDBStructure;
